/**
 * TikTok Organic Demographics — Shared Distribution Constants (IMC-17)
 *
 * Platform-typical distributions for TikTok organic demographics.
 * Used by both the adapter (tiktok-business.ts) and the fixture generator
 * to ensure consistency. Single source of truth — update here only.
 *
 * All distribution arrays sum to exactly 1.0.
 */

/** Minimum followers required for TikTok demographic data (AC #2) */
export const DEMOGRAPHICS_MIN_FOLLOWERS = 100;

/** Followers by gender distribution */
export const GENDER_DISTRIBUTION = [
  { gender: "female", percentage: 0.58 },
  { gender: "male", percentage: 0.39 },
  { gender: "other", percentage: 0.03 },
] as const;

/** Followers by country distribution (fashion/e-commerce typical) */
export const COUNTRY_DISTRIBUTION = [
  { country: "US", percentage: 0.35 },
  { country: "GB", percentage: 0.12 },
  { country: "CA", percentage: 0.08 },
  { country: "AU", percentage: 0.06 },
  { country: "DE", percentage: 0.05 },
  { country: "BR", percentage: 0.04 },
  { country: "FR", percentage: 0.04 },
  { country: "IN", percentage: 0.03 },
  { country: "MX", percentage: 0.03 },
  { country: "Other", percentage: 0.20 },
] as const;

/** Hourly audience activity distribution (UTC, sums to 1.0) */
export const HOURLY_ACTIVITY = [
  0.01, 0.005, 0.003, 0.002, 0.003, 0.005, 0.015, 0.03,
  0.04, 0.05, 0.06, 0.07, 0.075, 0.07, 0.06, 0.055,
  0.05, 0.06, 0.07, 0.075, 0.072, 0.06, 0.04, 0.02,
] as const;

/** Video views by country distribution */
export const VIEW_COUNTRY_DISTRIBUTION = [
  { country: "US", percentage: 0.40 },
  { country: "GB", percentage: 0.10 },
  { country: "CA", percentage: 0.08 },
  { country: "AU", percentage: 0.06 },
  { country: "DE", percentage: 0.05 },
  { country: "Other", percentage: 0.31 },
] as const;

/** Video views by gender distribution */
export const VIEW_GENDER_DISTRIBUTION = [
  { gender: "female", percentage: 0.55 },
  { gender: "male", percentage: 0.42 },
  { gender: "other", percentage: 0.03 },
] as const;

/** Traffic source distribution for organic content */
export const TRAFFIC_SOURCE_SHARES = [
  { source: "For You", share: 0.65 },
  { source: "Following", share: 0.15 },
  { source: "Profile", share: 0.08 },
  { source: "Search", share: 0.07 },
  { source: "Other", share: 0.05 },
] as const;
